function replace_ids(s) {
    var new_id = new Date().getTime();
    return s.replace(/NEW_RECORD/g, new_id);
}

jQuery(document).ready(function () {
    // Drag and drop functionality
    jQuery('#sort-questions').sortable({
        receive: function (event, ui) {
            jQuery.post(jQuery(this).data('delete-url'), jQuery(this).sortable('serialize'));
            event.preventDefault();
        },
        connectWith: ".sortable",
        appendTo: 'body'
    }).disableSelection();

    jQuery('#sort-stqs').sortable({
        receive: function (event, ui) {
            jQuery.post(jQuery(this).data('create-url'), jQuery(this).sortable('serialize'));
            event.preventDefault();
        },
        update: function (event, ui) {
            jQuery.post(jQuery(this).data('update-url'), jQuery(this).sortable('serialize'));
        },
        connectWith: ".sortable",
        appendTo: 'body'
    }).disableSelection();

    // Search functionality
    jQuery.expr[":"].contains = jQuery.expr.createPseudo(function (arg) {
        return function (elem) {
            return jQuery(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
        };
    });

    jQuery("#search_question_bank").keyup(function () {
        var searchText = jQuery(this).val();
        jQuery('.question-bank').hide();
        var selector = '.question-bank:contains("' + searchText + '")';
        jQuery(selector).show();
    });

    jQuery("#search_submission_template_questions").keyup(function () {
        var searchText = jQuery(this).val();
        jQuery('.submission-template-questions').hide();
        var selector = '.submission-template-questions:contains("' + searchText + '")';
        jQuery(selector).show();
    });

    // Add / remove nested items
    jQuery('a.add_nested_item').on('click', function () {
        var templateId = this.href.replace(/.*#/, '');
        var template = document.getElementById(templateId).innerHTML;
        jQuery('#' + this.rel).append(replace_ids(template)).children().children(':last').find(':text:visible:first').focus();
        return false;
    });

    // Other jQuery code
    if (jQuery(".glyphicon-remove-sign").length === 1000) {
        jQuery(".hide-me").html("Click your browser's back button to fix and resubmit");
        jQuery(".hide-me-too").hide();
        jQuery("input").prop("readonly", true);
        jQuery("select").attr("disabled", true);
        jQuery("textarea").prop("readonly", true);
    }

    var errs = jQuery('.error-message li')
    if (errs.length > 0) {
        errs.each(function () {
            var a = jQuery(this).attr('id');
            jQuery('.' + a).closest('div').addClass('has-error');
        });
    }
});
